import { Link } from 'react-router-dom';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="auth-logo">
          <img src="/mosaic-icon.png" alt="mosaime" className="logo-icon-img" />
          <span className="logo-text">mosaime</span>
        </Link>

        <div className="legal-card">
          <h1>Terms &amp; Conditions</h1>

          <div className="legal-body">
            <p><strong>Mosaime LLC – Terms &amp; Conditions</strong></p>
            <p>Last Updated: March 26, 2026</p>
            <p>Welcome to Mosaime LLC (&ldquo;Mosaime,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;). These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your use of our SMS&#8209;based wellness companion service and any related websites, applications, or content (collectively, the &ldquo;Service&rdquo;). By signing up or using the Service, you agree to these Terms.</p>

            <h3>1. SMS Messaging Consent</h3>
            <p>By creating an account or providing your phone number, you consent to receive automated SMS messages from Mosaime. Message frequency varies based on your usage and settings. Message and data rates may apply. Consent to receive SMS messages is not a condition of purchase.</p>
            <p>You may opt out at any time by texting STOP. For help, contact us at contact@mosaime.com.</p>

            <h3>2. Wellness&#8209;Only, Non&#8209;Medical Service</h3>
            <ul>
              <li>Mosaime provides general wellness guidance and lifestyle support.</li>
              <li>We do not provide medical advice, diagnosis, treatment, or therapy.</li>
              <li>The Service is not a substitute for professional medical care.</li>
              <li>Always consult a qualified healthcare provider for medical concerns.</li>
            </ul>

            <h3>3. User Responsibilities</h3>
            <p>You agree not to use the Service to send harmful, abusive, or unlawful content. You are responsible for maintaining the confidentiality of your account and for all activity under your account.</p>

            <h3>4. Privacy and Data</h3>
            <ul>
              <li>By using the Service, you agree to our <Link to="/privacy">Privacy Policy</Link>.</li>
              <li>SMS is not a secure communication channel. Do not send sensitive information such as medical details, financial information, or passwords.</li>
              <li>We may collect and store information you provide, including message content, usage data, and device information, to operate and improve the Service.</li>
            </ul>

            <h3>5. Fitbit Integration</h3>
            <p>By connecting your Fitbit account to Mosaime, you authorize us to access and use the data that Fitbit makes available through its API. This data may include activity metrics, sleep information, heart rate data, and other wellness&#8209;related information.</p>

            <h4>a. User Responsibilities</h4>
            <p>By connecting your Fitbit account, you confirm that:</p>
            <ul>
              <li>You have the right to connect your Fitbit account and authorize this access.</li>
              <li>The information provided through Fitbit is accurate to the best of your knowledge.</li>
              <li>You will comply with Fitbit&rsquo;s own terms of service and policies.</li>
            </ul>

            <h4>b. Use of Fitbit Data for Recommendations</h4>
            <p>You acknowledge that Mosaime may analyze your Fitbit data using automated systems, including AI models, to generate personalized recommendations, reminders, and insights. These recommendations are informational only and are not medical advice.</p>

            <h4>c. Data Retention</h4>
            <p>We retain Fitbit data as long as your account is active or as needed to provide the service. You may request deletion of your Fitbit data at any time by contacting us.</p>

            <h4>d. Revoking Access</h4>
            <p>You may disconnect your Fitbit account at any time through your Mosaime settings or through your Fitbit account settings. Once disconnected, we will stop receiving new data from Fitbit.</p>

            <h4>e. No Medical Advice</h4>
            <p>Fitbit data is used solely for general wellness and habit&#8209;support purposes. Mosaime is not a medical service and does not provide medical diagnosis, treatment, or advice.</p>

            <h3>6. Service Availability</h3>
            <p>The Service may be modified, suspended, or discontinued at any time without notice. We are not responsible for delays or failures in SMS delivery caused by carriers or third&#8209;party providers.</p>

            <h3>7. Disclaimers</h3>
            <p>The Service is provided &ldquo;as is&rdquo; without warranties of any kind. We do not guarantee accuracy, completeness, or results from using the Service.</p>

            <h3>8. Limitation of Liability</h3>
            <p>To the fullest extent permitted by law, Mosaime LLC is not liable for any indirect, incidental, consequential, or punitive damages arising from your use of the Service.</p>

            <h3>9. Governing Law</h3>
            <p>These Terms are governed by the laws of the State of New Jersey, without regard to conflict&#8209;of&#8209;law principles.</p>

            <h3>10. Changes to Terms</h3>
            <p>We may update these Terms at any time. Continued use of the Service constitutes acceptance of the updated Terms.</p>

            <h3>11. Contact</h3>
            <p>For questions or support, contact:<br />Mosaime LLC<br />contact@mosaime.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
